import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Alert } from "react-bootstrap";
import Header from "../Helper/Header";
import NewFooter from "../Helper/NewFooter";

const jobData = [
  {
    id: "Dsr0014",
    title: "Research Engineer (Chemical Engineer)",
    location: "Dsider | India",
    position: "Entry Level (1-3 years)",
    postedOn: "Sep 03rd 2025",
    travel: "Minimal",
    workModel: "Remote",
    country: "India",
    aboutDsider: "Dsider is an AI-powered decision intelligence platform for the energy sector. We help companies transform complexity into clarity using AI models, digital twins, and decision modeling tools — driving smarter, faster, and more profitable decisions across the energy value chain.",
    theRole: "We're looking for a Research Engineer with a Chemical Engineering background to develop and validate process models for energy transition technologies. You'll apply your chemical engineering expertise to create accurate simulations for hydrogen production, carbon capture, biofuels, and other emerging energy processes.",
    responsibilities: [
      "Develop and validate chemical process models for energy technologies",
      "Design thermodynamic and kinetic models for emerging energy processes",
      "Collaborate with software engineers to integrate process simulations into our platform",
      "Research and analyze new energy technologies and their process requirements",
      "Validate model outputs against experimental data and industry benchmarks",
      "Support customer implementations with domain expertise",
      "Contribute to technical documentation and best practices",
      "Stay current with developments in energy transition technologies"

    ],
    qualifications: [
      "1+ years of experience in chemical engineering or related field.",
      "Education: Bachelor's/Master's in Chemical Engineering or related discipline.",
      "Process Modeling: Experience with process simulation software (Aspen Plus, HYSYS, or similar).",
      "Thermodynamics: Strong foundation in thermodynamics, heat transfer, and mass transfer.",
      "Programming: Basic proficiency in Python, MATLAB, or similar technical computing languages.",
      "Energy Processes: Understanding of chemical processes in energy applications.",
      "Problem Solving: Strong analytical and problem-solving capabilities.",
      "Communication: Ability to explain complex technical concepts clearly.",
      "Documentation: Strong technical writing skills."
    ],
    goodToHave: [
      "Experience with emerging energy technologies (hydrogen, CCUS, biofuels, geothermal)",
      "Knowledge of reaction kinetics and catalyst design",
      "Experience with CFD or other advanced simulation tools",
      "Understanding of process optimization and control",
      "Familiarity with energy industry standards and regulations",
      "Experience with data analysis and statistical methods",
      "Knowledge of life cycle assessment (LCA) methodologies"

    ]
  },
  {
    id: "Dsr0022",
    title: "Backend Engineer",
    location: "Dsider | India",
    position: "Intermediate Level (3-5 years)",
    postedOn: "Sep 03rd 2025",
    travel: "Minimal",
    workModel: "Remote",
    country: "India",
    aboutDsider: "Dsider is an AI-powered decision intelligence platform for the energy sector. We help companies transform complexity into clarity using AI models, digital twins, and decision modeling tools — driving smarter, faster, and more profitable decisions across the energy value chain.",
    theRole: "We're looking for a Backend Engineer to build robust, scalable server-side applications that power our AI-driven energy solutions. You'll design and implement APIs, manage data pipelines, and ensure our systems can handle complex energy simulations and large-scale data processing.",
    responsibilities: [
      "Design and develop scalable backend services and APIs using modern frameworks",
      "Build and maintain data processing pipelines for energy sector applications",
      "Integrate with AI/ML models and simulation engines",
      "Implement database solutions for complex energy data structures",
      "Ensure system reliability, performance, and security",
      "Collaborate with frontend engineers, data scientists, and domain experts",
      "Participate in code reviews and maintain high code quality standards",
      "Support deployment and monitoring of production systems."
    ],
    qualifications: [
      "3+ years of backend development experience.",
      "Languages: Proficiency in Python or similar backend technologies.",
      "Frameworks: Experience with Python FastAPI, Django or equivalent.",
      "Databases: Strong experience with SQL (PostgreSQL/MySQL) and NoSQL (MongoDB/Redis).",
      "APIs: Design and implementation of RESTful APIs.",
      "Cloud Platforms: Experience with AWS and Azure.",
      "DevOps: Understanding of Docker, basic CI/CD, and version control with Git.",
      "Data Processing: Experience with data pipelines and ETL processes.",
      "Testing: Unit testing and integration testing practices."
    ],
    goodToHave: [
      "Experience with real-time data streaming and processing",
      "Knowledge of energy sector data formats and simulations",
      "Experience with AI/ML model deployment and serving",
      "Familiarity with microservices architecture",
      "Understanding of message queues and event-driven architectures",
      "Experience with monitoring and logging tools."
    ]
  },
  {
    id: "Dsr0020",
    title: "UX Designer",
    location: "Dsider | India",
    position: "Intermediate Level (3+ years)",
    postedOn: "January 15, 2026",
    travel: "Minimal",
    workModel: "Currently remote. Candidate willing to relocate to Bengaluru in future",
    country: "India, Bengaluru preferred (Remote will be considered)",
    aboutDsider: (
  <>
    Dsider is building an <strong>AI-powered decision platform</strong> grounded
    in <strong> first-principles simulation, optimization, and domain-specific knowledge. </strong>
    Our systems combine deterministic modeling, multi-agent AI, and
    explainable decision logic to help organizations make complex,
    high-impact decisions with confidence.
    As we scale globally, India is a critical engineering and delivery
    hub for Dsider.
  </>
),
    theRole: "We're looking for a UX Designer to create intuitive and powerful user experiences for our AI-driven energy platform. You'll design interfaces that make complex energy data and simulations accessible to engineers, executives, and decision-makers across the energy industry.",
    responsibilities: [
      "Design user-centered interfaces for complex energy data visualization and analysis tools",
      "Conduct user research and usability testing with energy industry professionals",
      "Create wireframes, prototypes, and high-fidelity designs using modern design tools",
      "Develop design systems and component libraries for consistent user experiences",
      "Collaborate closely with product managers, engineers, and domain experts",
      "Translate complex technical requirements into intuitive user workflows",
      "Present design concepts and rationale to stakeholders"
    ],
    qualifications: [
      "3+ years of UX design experience with increasing responsibility",
      "Design Tools: Proficiency in Figma, Sketch, Adobe Creative Suite, or similar tools",
      "User Research: Experience with user interviews, usability testing, and persona development",
      "Prototyping: Strong skills in creating interactive prototypes and wireframes",
      "Design Systems: Experience building and maintaining design systems and component libraries",
      "Data Visualization: Understanding of effective data visualization principles and best practices",
      "Responsive Design: Strong knowledge of responsive and adaptive design principles",
      "Collaboration: Excellent communication skills and experience working with cross-functional teams",
      "Problem Solving: Ability to translate complex business requirements into user-friendly solutions",
      "Portfolio: Strong portfolio demonstrating UX process and design thinking"
    ],
    goodToHave: [
      "Experience designing for data-heavy or enterprise applications",
      "Knowledge of energy sector workflows and industry-specific requirements",
      "Understanding of AI/ML interfaces and decision support systems",
      "Experience with design for technical/scientific applications",
      "Basic understanding of frontend development (HTML, CSS, JavaScript)",
      "Experience with accessibility standards (WCAG) and inclusive design",
      "Knowledge of information architecture and complex data organization"
    ]
  },
  {
    id: "Dsr0023",
    title: "Frontend Engineer",
    location: "Dsider | India",
    position: "Intermediate Level (3+ years)",
    postedOn: "Sep 12th 2025",
    travel: "Minimal",
    workModel: "Currently remote. Candidate willing to relocate to Bengaluru in future",
    country: "India, Bengaluru preferred (Remote will be considered)",
    aboutDsider: "Dsider is an AI-powered decision intelligence platform for the energy sector. We help companies transform complexity into clarity using AI models, digital twins, and decision modeling tools — driving smarter, faster, and more profitable decisions across the energy value chain.",
    theRole: "We're looking for a Frontend Engineer to develop engaging user interfaces for our AI-driven energy solutions. You'll build responsive web applications, implement data visualization components, and create intuitive user experiences that make complex energy data accessible to decision-makers.",
    responsibilities: [
      "Develop responsive web applications using modern frontend frameworks",
      "Implement interactive data visualizations and dashboards for energy data",
      "Collaborate with UX designers to transform designs into functional interfaces",
      "Integrate frontend applications with backend APIs and AI/ML services",
      "Optimize application performance and ensure cross-browser compatibility",
      "Write clean, maintainable code following established coding standards",
      "Participate in code reviews and contribute to team knowledge sharing",
      "Support testing and quality assurance processes"
    ],
    qualifications: [
      "3+ years of frontend development experience",
      "Frontend Frameworks: Proficiency in React, Angular, or Vue.js (React preferred)",
      "Languages: Strong skills in JavaScript/TypeScript, HTML5, and CSS3",
      "Responsive Design: Experience with responsive web design and CSS frameworks",
      "Version Control: Proficiency with Git and collaborative development workflows",
      "APIs: Experience integrating with RESTful APIs and handling asynchronous data",
      "Build Tools: Familiarity with modern build tools (Webpack, Vite, etc.)",
      "Testing: Understanding of frontend testing practices and frameworks",
      "Problem Solving: Strong debugging and problem-solving capabilities"
    ],
    goodToHave: [
      "Experience with data visualization libraries (D3.js, Chart.js, Plotly)",
      "Knowledge of state management libraries (Redux, MobX)",
      "Understanding of performance optimization techniques",
      "Experience with component libraries and design systems",
      "Familiarity with energy sector applications and data visualization needs",
      "Experience with progressive web apps (PWA)",
      "Understanding of accessibility standards and best practices"

    ]
  },
  {
    id: "Dsr0010",
    title: "Senior Frontend Engineer",
    location: "Dsider | India",
    position: "Senior Level (6+ years)",
    postedOn: "Sep 24th 2025",
    travel: "Minimal",
    workModel: "Currently remote. Candidate willing to relocate to Bengaluru in future",
    country: "India, Bengaluru preferred (Remote will be considered)",
    aboutDsider: "Dsider is an AI-powered decision intelligence platform for the energy sector. We help companies transform complexity into clarity using AI models, digital twins, and decision modeling tools — driving smarter, faster, and more profitable decisions across the energy value chain.",
    theRole: "We're looking for a Senior Frontend Engineer to lead our user interface development and create exceptional user experiences for our AI-driven energy solutions. You'll architect scalable frontend systems, mentor junior developers, and build intuitive interfaces that make complex energy data accessible and actionable.",
    responsibilities: [
      "Design and develop responsive, scalable web applications using modern frontend frameworks",
      "Lead frontend architecture decisions and establish coding standards and best practices",
      "Collaborate with UX designers, backend engineers, and data scientists to deliver seamless user experiences",
      "Optimize application performance and ensure cross-browser compatibility",
      "Mentor junior frontend developers and conduct code reviews",
      "Participate in technical discussions with customers and stakeholders",
      "Contribute to the full software development lifecycle from conception to deployment"
    ],
    qualifications: [
      "6+ years of frontend development experience with increasing responsibility",
      "Frontend Frameworks: Advanced proficiency in React, Angular, or Vue.js (React preferred)",
      "Languages: Expert-level JavaScript/TypeScript, HTML5, CSS3",
      "State Management: Redux, MobX, or similar state management libraries",
      "Build Tools: Webpack, Vite, or similar bundling tools",
      "Version Control: Git with experience in collaborative development workflows",
      "UI/UX: Strong understanding of responsive design principles and accessibility standards",
      "Testing: Unit testing with Jest, Cypress, or similar frameworks",
      "APIs: Integration with RESTful APIs and GraphQL",
      "Performance: Experience with performance optimization and web vitals"
    ],
    goodToHave: [
      "Experience with data visualization libraries (D3.js, Chart.js, or similar)",
      "Knowledge of energy sector applications and complex data interfaces",
      "Experience with micro-frontend architectures",
      "Familiarity with design systems and component libraries",
      "Experience with Progressive Web Apps (PWA)",
      "Understanding of AI/ML model integration in frontend applications"
    ]
  },
  {
    id: "Dsr0026",
    title: "Director of Engineering – India",
    location: "Dsider | India",
    position: "Senior Level - Reports to CEO",
    postedOn: "January 28, 2026",
    travel: "Minimal",
    workModel: "Currently remote. Candidate willing to relocate to Bengaluru in future",
    country: "India, Bengaluru preferred (Remote will be considered)",
    aboutDsider: (
  <>
    Dsider is building an <strong>AI-powered decision platform</strong> grounded
    in <strong> first-principles simulation, optimization, and domain-specific knowledge. </strong>
    Our systems combine deterministic modeling, multi-agent AI, and
    explainable decision logic to help organizations make complex,
    high-impact decisions with confidence.
    As we scale globally, India is a critical engineering and delivery
    hub for Dsider.
  </>
),
    theRole: (
      <>
      We are seeking a <strong>Director of Engineering for India</strong> to lead and scale Dsider’s India engineering organization. 
      This role owns <strong> execution, quality, security, and delivery</strong> across Front-End, Back-End, AI/Agentic systems, QA, and Security teams.
      This is a hands-on leadership role with responsibility for building teams, driving execution, and establishing operating discipline. 
      The role has a <strong> clear progression to VP of Operations (India)</strong>, owning end-to-end engineering and operational outcomes in the region along with business development and growth in India and largely in Asian countries.
<br/><br/>
      <strong>Growth Path</strong><br/>
This role is designed to evolve into VP of Operations (India), owning:
End-to-end engineering delivery in India
Operational excellence and scaling strategy
Budgeting, hiring, and vendor relationships
Execution alignment with global company goals
Sales in India and other Asian countries.  
      </>
    ),
    responsibilities: 
    (
  <>
    <strong>Engineering Leadership & Delivery</strong>
    <ul>
      <li>Lead and manage multi-disciplinary engineering teams across Front-End, Back-End, AI/Agentic systems, QA, and Security.</li>
      <li>Own delivery timelines, execution quality, and technical outcomes for India-based teams.</li>
      <li>Translate product and platform strategy into execution plans, roadmaps, and milestones.</li>
      <li>Ensure consistent, predictable delivery across multiple concurrent initiatives.</li>
    </ul>

    <strong>Technical Oversight</strong>
    <ul>
      <li>Provide technical leadership and architectural oversight across the full stack.</li>
      <li>Ensure engineering designs align with Dsider’s simulation, optimization, and agentic AI architecture.</li>
      <li>Partner with architects and senior engineers to review designs, manage technical risk, and drive scalability.</li>
      <li>Establish standards for performance, reliability, observability, and maintainability.</li>
    </ul>

    <strong>AI, Security & Quality</strong>
    <ul>
      <li>Oversee development of AI and multi-agent systems, ensuring correctness, explainability, and robustness.</li>
      <li>Ensure security best practices across the platform, including access control, data protection, and compliance readiness.</li>
      <li>Own QA strategy, test automation, validation processes, and release quality.</li>
    </ul>

    <strong>People & Org Leadership</strong>
    <ul>
      <li>Build, mentor, and retain high-performing engineering teams in India.</li>
      <li>Develop engineering managers and senior ICs into technical and people leaders.</li>
      <li>Establish clear ownership, accountability, and performance expectations.</li>
    </ul>

    <strong>Operational Excellence</strong>
    <ul>
      <li>Implement scalable engineering processes, including sprint planning, release management, and incident response.</li>
      <li>Drive continuous improvement across velocity, quality, and cost efficiency.</li>
      <li>Partner with global leadership on budgeting, hiring plans, and vendor management.</li>
    </ul>

    <strong>Cross-Functional & Global Collaboration</strong>
    <ul>
      <li>Act as the primary India engineering leader working with US-based product, architecture, and leadership teams.</li>
      <li>Ensure strong communication, alignment, and execution across time zones.</li>
    </ul>
  </>
    ),
    qualifications: (
      <>
      <ul>
      <li>10 years of engineering experience, with 4+ years in engineering leadership roles.</li>
      <li>Proven experience managing Front-End, Back-End, AI/ML, Security, and QA teams.</li>
      <li>Strong understanding of distributed systems, cloud platforms (AWS preferred), and modern software architectures.</li>
      <li>Experience scaling engineering teams in a startup or high-growth environment.</li>
      <li>Ability to balance hands-on technical depth with people and operational leadership.</li>
    </ul>
      </>
    ),
    goodToHave: [
      "Experience leading India-based engineering organizations for startups.",
      "Exposure to AI platforms, simulation systems, or data-intensive products.",
      "Familiarity with security frameworks (SOC2, ISO 27001) and compliance processes."
    ]
  },
  {
    id: "Dsr0027",
    title: "Data Analytics Engineer",
    location: "Dsider | USA",
    position: "Intermediate Level (3+ years)",
    postedOn: "August 21, 2026",
    travel: "Minimal",
    workModel: "Remote, with preference for candidates in Houston",
    country: "United States",
    aboutDsider: (
  <>
    Dsider is an AI-powered decision intelligence platform for the energy sector. 
    We help companies transform complexity into clarity using AI models, digital twins, 
    and decision modeling tools — driving smarter, faster, and more profitable decisions across the energy value chain.
  </>
),
    theRole: (
  <>
    We're looking for a <strong>Data Analytics Engineer</strong> to improve and build a product 
    that delivers useful analytics to customers while owning the ETL pipelines and database design
     that power reliable platform analytics. You will validate that platform outputs are accurate, 
     explainable, and useful for end users, and QA product accuracy by checking metrics, calculations,
      edge cases, and data assumptions against expected results. Over time, you will build 
      subject-matter fluency in petroleum and heavy-industry operations, though prior domain knowledge
       is not required.
  </>
),
    responsibilities: [
      "Design, build, and maintain ETL/ELT pipelines that ingest, transform, and load industrial and operational data into the platform",
      "Design and evolve database schemas, tables, and models that support accurate, scalable analytics",
      "Use Python for data analysis, pipeline logic, validation scripts, and product accuracy checks",
      "Perform EDA and data quality analysis to characterize datasets, spot anomalies, and identify gaps before they affect product outputs",
      "Analyze how the platform handles real datasets and where accuracy, performance, or usability breaks down",
      "Test and validate product logic for operational and commercial metrics (e.g., production, downtime, throughput, cost)",
      "Reproduce accuracy issues, isolate root causes in data pipelines or schema design, and confirm fixes before release",
      "Partner with product and engineering to tighten definitions, improve data handling, and raise confidence in platform outputs",
      "Document data models, pipeline logic, assumptions, and validation checks so work is repeatable",
      "Help prioritize platform improvements based on impact to analytical correctness, data reliability, and user trust"
    ],
    qualifications: [
      "Strong analytical skills and comfort with imperfect, multi-source data",
      "Experience with EDA and data quality analysis (profiling, completeness, consistency, anomaly detection)",
      "Hands-on experience with ETL/ELT and SQL",
      "Expected fluency in Python for data work (analysis, transforms, automation, and validation)",
      "Experience designing relational databases / analytical schemas (normalization, keys, indexing)",
      "A QA mindset for analytical products: verifying logic, catching edge cases, and proving correctness",
      "Clear communication with product, engineering, and domain stakeholders",
      "Curiosity about industrial / petroleum production systems and willingness to learn the domain on the job",
      "Experience using AI tools and building agentic workflows.  RAG experience is a plus.",
      "Ability to build reliable ETL pipelines and well-designed databases that support trustworthy analytics",
      "Strong focus on analytical accuracy, with the ability to identify, investigate, and prevent recurring data and logic issues",
      "Ability to quickly detect, troubleshoot, and resolve incorrect metrics, data-quality issues, and edge-case failures",
      "Willingness and ability to develop fluency in petroleum and heavy-industry operations while learning the domain on the job",
      "Bonus (not required): cloud data warehouses, orchestration tools, or pipeline frameworks",
      "Bonus (not required): background in manufacturing, energy, oil & gas, or other heavy industry"
    ],
    goodToHave: [
      "Familiarity with time-series or sensor/operational data",
      "Experience writing acceptance criteria or validation checklists for analytics products",
      "Basic statistical methods for variance checks, anomaly detection, or forecast validation",
      "Comfort working closely with domain experts and customer-facing product teams"
    ]
  }
];

const JobDetails = () => {

  const { jobId } = useParams();
  const [job, setJob] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    currentSalary: "",
    expectedSalary: "",
    yearsOfExperience: "",
    resume: null,
    referralSource: ""
  });

  const [message, setMessage] = useState({ status: 0, value: "" });

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const foundJob = jobData.find((j) => j.id === jobId);
    setJob(foundJob);
  }, [jobId]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "resume") {
      setFormData({ ...formData, resume: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  if (!job) {
    return <p style={{ padding: "2rem" }}>Job not found</p>;
  }

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(",")[1]); // remove prefix
      reader.onerror = (error) => reject(error);
    });
  };

  async function handleSubmit() {
    if (isSubmitting) return; // prevent double clicks

    setIsSubmitting(true);

    try {
      const headers = {
        "Content-Type": "application/json",
        "Accept": "application/json",
      };

      let fileBase64 = null;
      let fileName = null;
      if (formData.resume) {
        fileBase64 = await fileToBase64(formData.resume);
        fileName = formData.resume.name;
      }

      if (!formData.resume) {
        setMessage({ status: 0, value: "Please upload your resume before submitting." });
        setTimeout(() => setMessage({ status: 0, value: "" }), 3000);
        return;
      }

      const requestData = {
        sheet_id: "1voJ7ozFGYqE-mbelORkiXGmhB-97E-Bn6Qvl0Px-3bU",
        identifier: "sheet_and_drive",
        sheet_name: "Careers",
        data: {
          "JobID": jobId,
          "JobTitle": job.title,
          "Name": formData.name,
          "Email": formData.email,
          "currentSalary": formData.currentSalary,
          "expectedSalary": formData.expectedSalary,
          "YearsOfExperience": formData.yearsOfExperience,
          "Source": formData.referralSource,
          "AppliedOn": new Date().toLocaleDateString("en-GB"),
        },
        file_base64: fileBase64,
        file_name: fileName,
        folder_id: "0AFFLkDSFN5r1Uk9PVA"
      };
      const response = await axios.post(
        "https://5l2ipjsrylacx3h7cxu4sqob6y0lnfsv.lambda-url.us-east-1.on.aws",
        requestData, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        mode: 'cors'  // Added CORS mode here
      });
      if (response.status >= 200 && response.status < 300) {
        setMessage({ status: 1, value: "Application submitted successfully." });
        setTimeout(() => setMessage({ status: 0, value: "" }), 3000);
        // Reset form
        setFormData({
          name: "",
          email: "",
          currentSalary: "",
          expectedSalary: "",
          yearsOfExperience: "",
          resume: null,
          referralSource: ""
        });
      } else {
        throw new Error(`Request failed with status ${response.status}`);
      }
    } catch (error) {
      console.error("Full error:", error);
      setMessage({
        status: 0,
        value: error.response?.data?.message ||
          "There was a problem sending your request. Please try again later.",
      });
    }
    finally {
      setIsSubmitting(false);
    }
  }


  return (
    <>
      <Header />
      <div className="job-details-wrapper">
        <div className="job-details-container">
          <h2 className="job-title" style={{ marginTop: "2rem" }}>{job.title} <br />
            ({job.location})</h2>

          <h4 className="job-section-title">About Dsider:</h4>
          <p className="job-paragraph">{job.aboutDsider}</p>
          <h4 className="job-section-title">The Role:</h4>
          <p className="job-paragraph">{job.theRole}</p>

            <h4 className="job-section-title">Key Responsibilities:</h4>
            {/* <ul className="job-list">
              {job.responsibilities.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul> */}
            {Array.isArray(job.responsibilities) ? (
  <ul className="job-list">
    {job.responsibilities.map((item, index) => (
      <li key={index}>{item}</li>
    ))}
  </ul>
) : (
  <div className="job-description">
    {job.responsibilities}
  </div>
)}

          <h4 className="job-section-title">Qualifications:</h4>
          {/* <ul className="job-list">
            {job.qualifications.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul> */}
          {Array.isArray(job.qualifications) ? (
  <ul className="job-list">
    {job.qualifications.map((item, index) => (
      <li key={index}>{item}</li>
    ))}
  </ul>
) : (
  <div className="job-description">
    {job.qualifications}
  </div>
)}

          <h4 className="job-section-title">Nice-To-Haves:</h4>
          <ul className="job-list">
            {job.goodToHave.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>

          <h4 className="job-section-title">Work Model</h4>
          <p style={{ fontSize: "16px" }}><strong>Location:</strong> {job.country}<br />
            <strong>Work Model:</strong> {job.workModel}<br />
            <strong>Travel:</strong> {job.travel}</p>
          <br />

          <div className="application-form-section">
            <h4>Fill Details to Apply</h4>
            <form onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }} className="application-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Name*</label>
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email*</label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
                </div>
              </div>
              {!job.location.includes("USA") && (
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="currentSalary">Current Salary*</label>
                    <input type="text" id="currentSalary" name="currentSalary" value={formData.currentSalary} onChange={handleChange} required />
                  </div>
                  <div className="form-group">
                    <label htmlFor="expectedSalary">Expected Salary*</label>
                    <input type="text" id="expectedSalary" name="expectedSalary" value={formData.expectedSalary} onChange={handleChange} required />
                  </div>
                </div>
              )}
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="yearsOfExperience">Years of Experience*</label>
                  <input
                    type="text"
                    id="yearsOfExperience"
                    name="yearsOfExperience"
                    value={formData.yearsOfExperience}
                    onChange={handleChange}
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onPaste={(e) => {
                      const paste = (e.clipboardData || window.clipboardData).getData("text");
                      if (!/^[0-9]+$/.test(paste)) {
                        e.preventDefault();
                      }
                    }}
                    required
                  />
                </div>
                <div className="form-group full-width">
                  <label htmlFor="referralSource">How did you get to know about this job?</label>
                  <select
                    id="referralSource"
                    name="referralSource"
                    value={formData.referralSource}
                    onChange={handleChange}
                    className="form-control" style={{ padding: "0.40rem 0.75rem", borderRadius: "6px", lineHeight: "2" }}
                    required
                  >
                    <option value="">-- Select an option --</option>
                    <option value="LinkedIn">LinkedIn</option>
                    <option value="Google Search">Google Search</option>
                    <option value="Dsider Team">Dsider Team</option>
                    <option value="Others">Others</option>
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <div className="upload-header">
                    <label htmlFor="resume">Upload Resume*
                      <span className="upload-note" style={{ padding: 10 }}>Max (5mb)</span>
                    </label>
                  </div>
                  <label htmlFor="resume" className="upload-label" style={{ width: "48%" }}>Select file</label>
                  <input
                    type="file"
                    id="resume"
                    name="resume"
                    accept=".pdf,.doc,.docx"
                    onChange={handleChange}
                    className="hidden-input"
                  />
                  {formData.resume && (
                    <p className="file-name-preview">📄 {formData.resume.name}</p>
                  )}
                </div>
              </div>
              {message.value && message.value !== "" && (
                <Alert
                  variant={message.status === 1 ? "success" : "danger"}
                  className="mt-3"
                >
                  {message.value}
                </Alert>
              )}

              {/* <div className="recaptcha-placeholder">[ reCAPTCHA goes here ]</div> */}

              <div className="form-row btn-row center-buttons">
                <button
                  type="button"
                  className="reset-btn"
                  onClick={() => {
                    setFormData({
                      name: "",
                      email: "",
                      currentSalary: "",
                      expectedSalary: "",
                      yearsOfExperience: "",
                      resume: null,
                      referralSource: ""
                    });
                    document.querySelector('input[type="file"]').value = "";
                  }}
                >
                  Reset
                </button>
                <button type="submit" className="submit-btn" disabled={isSubmitting}>
                  {isSubmitting ? (
                    <>
                      Submitting <span className="spinner"></span>
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>
      <NewFooter />
    </>
  );
};

export default JobDetails;
